import { useInventory, useNavigation } from "@utilities/hooks";
import { useEffect, useMemo, useState } from "react";

export const useController = () => {

    const { goBack } = useNavigation();
    const { invertories, onGetAllOrganisationInvertories } = useInventory();

    const [selectedInventoryFilter, setSelectedInventoryFilter] = useState<string>('');
    const [searchProduct, setSearchProduct] = useState<string>('');

    const invertoriesDetails = useMemo(() => {
        if (!invertories) return [];

        return invertories?.details.filter((detail) => {
            const matchesSearch = detail.productName?.toLowerCase().includes(searchProduct.toLowerCase()) || false;
    
            const matchesStatus =
                !selectedInventoryFilter || detail.status.toLowerCase() === selectedInventoryFilter.toLowerCase();
    
            return matchesSearch && matchesStatus;
        })
    }, [invertories, searchProduct, selectedInventoryFilter]);

    useEffect(()=> {
        onGetAllOrganisationInvertories();
    }, []);

    return { 
        invertoriesDetails, invertories,
        selectedInventoryFilter,
        goBack, setSearchProduct,
        setSelectedInventoryFilter,
    }
}
